export default __webpack_public_path__ + "maps-examples-fill-pattern-1200-418ba4c6cb67d54575f76aefd1569ff1.webp";